import React, { useEffect, useState } from 'react';
{/* ===== Do not remove this IdTokenData =====*/ }
import { IdTokenData } from './DataDisplay';
import { useMsal } from '@azure/msal-react';
import { createClaimsTable } from '../../utils/claimUtils';
import * as action from '../../actions/login';
import * as storage from '../../utils/storage';
import { withCookies, Cookies } from 'react-cookie';
import { login, errorRedirect, errorSSORedirect } from '../../utils/redirect';
import LoginCompany from './LoginCompany';
import { generateToken } from '../../actions/authentication';
import * as LoginCode from '../../scripts/StatusLoginCode';
import { withNamespaces } from 'react-i18next';
import i18next from 'i18next';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    divDescription: {
        width: '100%',
        textAlign: 'center',
        marginTop: '50px'
    }
}));

const LoginEntra = (props) => {
    const classes = useStyles();

    /**
     * useMsal is hook that returns the PublicClientApplication instance,
     * that tells you what msal is currently doing. For more, visit:
     * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/hooks.md
     */
    const { instance } = useMsal();

    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [email, setEmail] = useState('');
    //const [activeAccount, setActiveAccount] = useState(instance.getActiveAccount());
    const [openLoginCompany, setOpenLoginCompany] = useState(false);
    const [companies, setCompanies] = useState([]);

    const intervalWaitSSO = storage.getConfigIntervalWaitSSO() ?? 3000;

    const maxTry = 3;
    let tryLogin = 0;

    useEffect(() => {
        handleLoginEntra();
    }, []);

    useEffect(() => {
        if (isAuthenticated) {
            action.loginUserSSO(email, storage.getConnectionString().value)
                .then(result => {
                    switch (result.statusLogin) {
                        case LoginCode.LOGIN_FAILED:
                        case LoginCode.LOGIN_USERLOCKED:
                        case LoginCode.LOGIN_TEMPORARILYUNAVAILABLE:
                        case LoginCode.LOGIN_RESTRICTEDEMPLOYEEHIRED:
                        case LoginCode.LOGIN_PASSWORDFIRSTSETUP:
                        case LoginCode.LOGIN_CHANGEPASSWORD:
                            errorRedirect();
                        case LoginCode.LOGIN_SSOUSERNOTLINKED:
                            errorSSORedirect();
                        case LoginCode.LOGIN_MULTIPLECOMPANIES:
                            handleMultipleCompanies(result.companies);
                            break;
                        default:
                            action.connectApp(props, true);
                    }
                }).catch((error) => {
                    errorRedirect();
                });
        }
    }, [isAuthenticated]);

    const handleLoginEntra = () => {
        setInterval(() => {
            tryLogin++;

            if (tryLogin <= maxTry) {
                const activeAccount = instance.getActiveAccount();
                if (activeAccount != null) {
                    const tokenClaims = createClaimsTable(activeAccount.idTokenClaims);

                    const emailSSO = tokenClaims.filter(x => x[0] == 'preferred_username')[0][1];

                    setEmail(emailSSO);

                    storage.saveIsSSO(true);

                    setIsAuthenticated(emailSSO.length > 0);
                }
            } else {
                login();
            }
        }, intervalWaitSSO);
    }

    const handleMultipleCompanies = (companies) => {
        storage.saveCompanies(companies);
        setOpenLoginCompany(true);
        setCompanies(companies);
    }

    const handleCloseLoginCompany = () => {
        setOpenLoginCompany(false);
    }

    const handleOnChangeLoginCompany = async (company) => {
        var result = await generateToken(company);

        if (result) {
           action.connectApp(props, true);
        } else {
            errorRedirect();
        }
    }

    return (
        <div>
            <LoginCompany openLoginCompany={openLoginCompany} handleClose={handleCloseLoginCompany} companies={companies} onChange={handleOnChangeLoginCompany} />

            {!openLoginCompany && <div className={classes.divDescription}>
                <span>{i18next.t('login:login.message.processRequest')}</span>
            </div>}

            {/* ===== Do not remove this section =====*/}
            {/*activeAccount ? (
                <div className={classes.divDescription}>
                    IF YOU WANT TO SEE THE MICROSOFT LOGIN RETURN <IdTokenData idTokenClaims={activeAccount.idTokenClaims} />
                </div>
            ) : <span>Error</span>*/}
            {/* ===== Do not remove this section =====*/}

        </div>
    )
}

export default withNamespaces(['login'], { wait: true })(withCookies(LoginEntra));